import { isString, SBaseDisplay } from '@summit/core';
import { MoneyFormatter } from '@summit/models';

import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { Company } from '../../organization/company/company';
import { PaySchedule, PayScheduleMapping } from '../../payroll/shared/pay-schedule.enum';
import { WageExtraType, WageExtraTypeMapping } from './wage-extra-type.enum';

export class EmployeeWageExtra extends EboObjectTO implements SBaseDisplay {
  employeeWageID: string;
  type: WageExtraType;
  companyId: string;
  company: Company;
  requireApprovedPay: boolean;
  schedule: PaySchedule;
  amount: number;
  comment: string;

  constructor(jsonData?: Partial<EmployeeWageExtra>) {
    super(jsonData);
    if (jsonData) {
      this.employeeWageID = jsonData.employeeWageID;
      if (isString(this.type)) this.type = parseInt(this.type, 10);
      if (isString(this.schedule)) this.schedule = parseInt(this.schedule, 10);
      if (jsonData?.company) this.company = new Company(jsonData?.company);
    }
    this.requireApprovedPay ??= false;
    //console.log('extra', this);
  }

  toShortString(): string {
    let response =
      `${PayScheduleMapping[this.schedule]}${this.requireApprovedPay ? ' if Worked' : ''} - ` +
      `${WageExtraTypeMapping[this.type]}: ${MoneyFormatter(this.amount)}`;
    if (this.company) response = `[${this.company.abbreviation}] ${response}`;
    if (this.comment) response += ` - ${this.comment}`;
    return response;
  }
}
